import { StyleSheet } from 'react-native';
import { Colors } from '@rivallapp/volosports-components';

export default StyleSheet.create({
  dropinContainer: {
    display: 'flex',
    position: 'relative',
    borderWidth: 1,
    borderColor: Colors.greys.light,
    borderRadius: 5,
    backgroundColor: Colors.white,
    paddingVertical: 15,
    // @ts-ignore - React Native doesn't support this anymore
    width: 'fit-content',
  },

  dropinRoster: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 350,
    padding: 1,
  },

  unassignedText: {
    fontSize: 14,
    paddingHorizontal: 5,
  },

  // recreating web 'default & small' button until we have something in theme
  switchButton: {
    backgroundColor: Colors.white,
    borderColor: Colors.greys.light,
    borderWidth: 1,
    borderRadius: 30,
    marginBottom: 10,
    height: 25,
  },

  switchText: {
    fontSize: 14,
  },
});
